import React from 'react';
export var LibraryUploadStep;
(function (LibraryUploadStep) {
  LibraryUploadStep["LIBRARY_IMAGE_PANEL"] = "library_image_panel";
  LibraryUploadStep["LIBRARY_VIDEO_PANEL"] = "library_video_panel";
  LibraryUploadStep["CLOSE"] = "close";
  LibraryUploadStep["LOCAL_CROP"] = "crop";
  LibraryUploadStep["IMAGE_URL_CROP"] = "image_url_crop";
  LibraryUploadStep["SUCCESS"] = "success";
  LibraryUploadStep["FAIL"] = "fail";
  LibraryUploadStep["UPLOADING"] = "uploading";
})(LibraryUploadStep || (LibraryUploadStep = {}));
export var MaterialPanelContext = React.createContext(null);